/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getTickerBidders } from '../fn/ticker-bidder/get-ticker-bidders';
import { GetTickerBidders$Params } from '../fn/ticker-bidder/get-ticker-bidders';
import { TickerBidderDto } from '../models/ticker-bidder-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedTickerBidderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTickerBidders()` */
  static readonly GetTickerBiddersPath = '/api/ticker/bidders/{ids}';

  /**
   * Gets one or more bidders by their ids.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTickerBidders()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerBidders$Response(params: GetTickerBidders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TickerBidderDto>>> {
    return getTickerBidders(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets one or more bidders by their ids.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTickerBidders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerBidders(params: GetTickerBidders$Params, context?: HttpContext): Observable<Array<TickerBidderDto>> {
    return this.getTickerBidders$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TickerBidderDto>>): Array<TickerBidderDto> => r.body)
    );
  }

}
